import { createClient } from "@supabase/supabase-js";

const clientsParProjet = new Map();

export function createSupabaseClient(projectId, apiKey) {
  const projet = String(projectId || "").trim();
  const cle = String(apiKey || "").trim();
  if (!projet || !cle) throw new Error("Configuration Supabase incomplète.");

  const url = /^https?:\/\//i.test(projet) ? projet.replace(/\/$/, "") : `https://${projet}.supabase.co`;

  if (!clientsParProjet.has(url)) {
    clientsParProjet.set(url, createClient(url, cle));
  }

  return clientsParProjet.get(url);
}
